"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'share.conversation.loading': 'Ładowanie rozmowy...',
    'share.conversation.noIdProvided': 'Nie podano ID rozmowy',
    'share.conversation.failedToLoad': 'Nie można załadować rozmowy',
    'share.conversation.untitled': 'Rozmowa bez tytułu',
    'share.conversation.linkCopied': 'Link skopiowany do schowka',
    'share.conversation.linkCopyFailed': 'Nie można skopiować linku',
    'share.conversation.copyLink': 'Kopiuj link',
    'share.conversation.goToChat': 'Przejdź do czatu',
    'share.conversation.you': 'Ty',
    'share.conversation.assistant': 'Asystent',
    'share.conversation.reasoning': 'Rozumowanie',
    'share.conversation.thoughts': 'Myśli',
    'share.conversation.sources': 'Źródła',
    'share.conversation.toolsUsed': 'Używane narzędzia',
    'share.conversation.noMessages': 'Nie znaleziono wiadomości',
    'share.conversation.noMessagesDescription': 'Ta rozmowa wydaje się być pusta lub wiadomości nie mogły zostać załadowane.',
    'share.conversation.footerNote': 'To jest udostępniona rozmowa. Możesz rozpocząć własny czat, aby wchodzić w interakcję z AI.',
    'share.conversation.startNewChat': 'Rozpocznij nowy czat',
    'share.conversation.unknownModel': 'Nieznany model',
    'share.conversation.unknownFile': 'Nieznany plik',
    'share.conversation.unknownSize': 'Nieznany rozmiar',
};
